import React, { useEffect, useState, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});
import { supabase } from '../supabaseClient';

export default function ProjectMap() {
  const [projects, setProjects] = useState([]);
  const [bounds, setBounds] = useState([]);
  const mapRef = useRef();

  useEffect(() => {
    const fetchProjects = async () => {
      const { data: projectsData, error: projectsError } = await supabase
        .from('projects')
        .select('id, name, status, project_number, client_id');

      const { data: locationsData, error: locationsError } = await supabase
        .from('project_locations')
        .select('project_id, latitude, longitude');

      // Fetch clients and permits
      const { data: clientsData } = await supabase
        .from('clients')
        .select('id, name');

      const { data: permitsData } = await supabase
        .from('project_records')
        .select('project_id, status, expiration_date');

      if (!projectsError && !locationsError && projectsData && locationsData) {
        const enriched = projectsData.map(project => {
          const loc = locationsData.find(l => l.project_id === project.id);
          if (!loc) return null;

          const client = clientsData?.find(c => c.id === project.client_id);
          const projectPermits = permitsData?.filter(p => p.project_id === project.id) || [];
          const summary = { Active: 0, 'In Progress': 0 };
          projectPermits.forEach(p => {
            if (p.expiration_date) {
              summary.Active += 1;
            } else {
              summary['In Progress'] += 1;
            }
          });

          return {
            ...project,
            client_name: client?.name || 'N/A',
            project_locations: {
              latitude: loc.latitude,
              longitude: loc.longitude
            },
            permit_summary: summary
          };
        }).filter(Boolean);

        setProjects(enriched);
        setBounds(enriched.map(p => [
          parseFloat(p.project_locations.latitude),
          parseFloat(p.project_locations.longitude)
        ]));
      }
    };

    fetchProjects();
  }, []);

  return (
    <div style={{ height: '100vh', width: '100vw' }}>
      <MapContainer
        center={[26.6406, -81.8723]}
        zoom={8}
        style={{ height: '100%', width: '100%' }}
        ref={mapRef}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {projects.map(project => (
          <Marker
            key={project.id}
            position={[
              parseFloat(project.project_locations.latitude),
              parseFloat(project.project_locations.longitude)
            ]}
          >
            <Popup>
              <strong>{project.name}</strong><br />
              Project #: {project.project_number}<br />
              Client: {project.client_name}<br />
              Status: {project.status}<br />
              Permit Status:
              <ul style={{ margin: '4px 0', paddingLeft: '16px' }}>
                {Object.entries(project.permit_summary).map(([status, count]) => (
                  <li key={status}>{status}: {count}</li>
                ))}
              </ul>
            </Popup>
          </Marker>
        ))}
        <FitBoundsHandler bounds={bounds} />
      </MapContainer>
    </div>
  );
}

function FitBoundsHandler({ bounds }) {
  const map = useMap();
  useEffect(() => {
    if (bounds && bounds.length > 0) {
      map.flyToBounds(bounds, { padding: [50, 50] });
    }
  }, [bounds, map]);
  return null;
}